module.exports = __webpack_public_path__ + "img/avatar_5.3aea42bf.jpg";